/**
 * The numbers and names the season review ("Your season so far", then "Your
 * 2026 season") is tuned by on the app's side: how many of the gardener's
 * photos its picture carries, the keys its asks are marked under, and the
 * query keys. What the season is, when it has ended, when it is offered and
 * when each ask is due are the backend's (services/season,
 * config/tunables/season there), read through GET /season; the gardener's
 * choice of season is kept on their account (preferences.seasonReviewBy).
 *
 * Kept out of the components so each can be found and changed without
 * reading the screen that uses it, and so they can later come from the
 * database (each carries its kept-values group, scripts/kept-values.md). Constants only.
 *
 * Used by: features/season (SeasonReviewPage, SeasonMoments, lib/useSeason); shared/lib/briefFreshness writes the
 * brief's key word again (SEASON_BRIEF_KEY), as it reads no value file.
 *
 * @module tunables/seasonReview
 */

/**
 * The most of the gardener's photos the season picture carries. Four fill a
 * two-by-two grid; more would be too small to see on a phone.
 * Unit: photos
 * @kept K4
 */
export const SEASON_REVIEW_MAX_PHOTOS = 4;

/**
 * The React Query key the season brief (getSeason) is cached under, followed
 * by the gardener, the day, the language, the unit, the year asked for and
 * the choice of season a screen asked for ('kept' for the account's own,
 * which the server reads). shared/lib/briefFreshness writes the same word
 * (SEASON_BRIEF_KEY) to mark the brief stale.
 * @kept K1
 */
export const SEASON_QUERY_KEY = 'season';

/**
 * How long a season brief read stays fresh before a visit reads it again (W24 Job H; it was read on every visit). A
 * write that changes the garden marks it stale sooner (shared/lib/briefFreshness gardenWritten, seasonWritten), so a
 * new photo or note still reaches the diary at once. An engineering value, not a gardener's.
 * Unit: milliseconds
 * @kept K1
 */
export const SEASON_BRIEF_STALE_MS = 5 * 60 * 1000;

/**
 * The pause after the last change before the season picture is drawn again,
 * so typing a line draws it once rather than per letter.
 * Unit: milliseconds
 * @kept K4
 */
export const SEASON_REVIEW_REDRAW_DELAY_MS = 350;
